import React, { useState } from "react";
import { withStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import TextField from "@material-ui/core/TextField";

import FeatureLayer from "@arcgis/core/layers/FeatureLayer";

const CHARACTER_LIMIT = 50;

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
    backroundColor: "#ffffff",
  },
  closeButton: {
    position: "absolute",
    right: theme.spacing(1),
    top: theme.spacing(1),
  },
});

const DialogTitle = withStyles(styles)((props) => {
  const { children, classes, onClose, ...other } = props;

  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography variant="h6">{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
}))(MuiDialogContent);

const DialogActions = withStyles((theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(1),
  },
}))(MuiDialogActions);

const RenameDialog = withStyles((theme) => ({
  paper: {
    backgroundColor: "#ffffff",
  },
}))(Dialog);

const RenameDialogCancelButton = withStyles((theme) => ({
  root: {
    color: theme.palette.primary.main,
  },
}))(Button);

const RenameAlert = ({
  renameAlertOpen,
  setRenameAlertClose,
  feature,
  userInfo,
  setTripName,
}) => {
  const [newName, setNewName] = useState("");

  const handleSetName = (e) => {
    if (e.target.value.length <= CHARACTER_LIMIT) {
      setNewName(e.target.value);
    }
  };

  const submitHandler = async () => {
    const tripHistoryUrlLayer = new FeatureLayer({
      url: userInfo.tripHistoryUrl,
    });

    // Update record with attachment id
    feature.attributes.TripName = newName;

    let features = [feature];
    try {
      let updateRes = await tripHistoryUrlLayer.applyEdits({
        updateFeatures: features,
      });
      setTripName(newName);
    } catch {
      alert(
        "Error occurred renaming recorded trip, please contact administrator."
      );
    }

    setRenameAlertClose();
  };

  return (
    <div>
      <RenameDialog
        onClose={setRenameAlertClose}
        aria-labelledby="customized-dialog-title"
        open={renameAlertOpen}
      >
        <DialogTitle id="customized-dialog-title" onClose={setRenameAlertClose}>
          Rename Trip
        </DialogTitle>
        <DialogContent dividers>
          <form
            noValidate
            autoComplete="off"
            onChange={handleSetName}
            style={{ width: "25ch" }}
          >
            <TextField
              id="filled-basic"
              value={newName}
              variant="filled"
              helperText={`${newName.length}/${CHARACTER_LIMIT}`}
            />
          </form>
        </DialogContent>
        <DialogActions>
          <RenameDialogCancelButton
            autoFocus
            onClick={setRenameAlertClose}
            style={{ color: "#B52626" }}
          >
            CANCEL
          </RenameDialogCancelButton>
          <RenameDialogCancelButton autoFocus onClick={submitHandler}>
            RENAME
          </RenameDialogCancelButton>
        </DialogActions>
      </RenameDialog>
    </div>
  );
};

export default RenameAlert;
